export const initialState = {
  items: void 0,
};

export default (state = initialState, action = {}) => {
  const { type, payload } = action;
  let newState = {};
  switch (type) {
    case "ROUTER_LOCATION_CHANGED":
      const { result = {} } = payload;
      const { breadcrumbs = [] } = result;
      newState = {
        ...state,
        items: breadcrumbs,
      };
      break;
    default:
      newState = {
        ...state,
      };
      break;
  }
  return newState;
};



// WEBPACK FOOTER //
// ./src/state/Breadcrumbs/reducers/breadcrumbReducer.js